export default __webpack_public_path__ + "static/media/defaultBGAssessmentCard.ac2896c9.png";